import type { JSX, ReactNode } from 'react'
import styled from 'styled-components'

import { AdditionalRoleToggles } from './AdditionalRoleToggles'
import { RoleDetails } from './RoleDetails'

import { Client, Role } from 'api/clients'
import { RoleSelect } from 'shared/components/RoleSelect'
import { getPrimaryRole, switchPrimaryRole } from 'utils/roles'

const StyledRoleDetails = styled(RoleDetails)`
  margin-top: 15px;
`

export type RoleFieldsProps = {
  allRoles: Role[]
  primaryRoles: Role[]
  selectedRoles: Role[]
  onChange(nextRoles: Role[]): void
  client: Client
  isDownloadEnabled: boolean
  // an owner's role can only be transferred, not changed here
  primaryRoleLockedReason?: ReactNode
}

// Used by the Invite, Edit Team Member, and Edit Pending Invite modals
export function RoleFields({
  allRoles,
  primaryRoles,
  selectedRoles,
  onChange,
  client,
  isDownloadEnabled,
  primaryRoleLockedReason,
}: RoleFieldsProps): JSX.Element {
  return (
    <>
      <label htmlFor="role">Role</label>
      {primaryRoleLockedReason}
      <RoleSelect
        disabled={Boolean(primaryRoleLockedReason)}
        onChange={(primaryRole) => onChange(switchPrimaryRole(primaryRole, selectedRoles))}
        outline={true}
        roles={primaryRoles}
        value={getPrimaryRole(selectedRoles)}
      />
      <AdditionalRoleToggles
        allRoles={allRoles}
        client={client}
        isDownloadEnabled={isDownloadEnabled}
        onChange={onChange}
        selectedRoles={selectedRoles}
      />
      <StyledRoleDetails roles={selectedRoles} />
    </>
  )
}
